import { ClientSettingPayloadModel } from '../models/clinetSettingPayloadModel'
import serviceDataAccess from '../services/service.data-access'
import { eventBus } from './eventBus'

const state = {
  footerSettings: {},
  headerSettings: {},
  config: {},
  clientSettings: {},
  currentLocalization: {},
  contactsSettings: {}
}

const getters = {
  footerItems: state => state.footerSettings,
  headerItems: state => state.headerSettings,
  getApiBasePath: state => state.config.apiBasePath,
  clientSettings: state => state.clientSettings,
  localization: state => state.currentLocalization,
  contactsSettings: state => state.contactsSettings,
  currentLocalization: state => state.currentLocalization
}

const actions = {
  async loadContactSettings(context) {
    const contactsSettings = await serviceDataAccess.getContactsSettings()
    context.commit('setContactsSettings', contactsSettings)
    eventBus.$emit('isLoad')
  },
  async loadFooterSettings(context) {
    const footerSettings = await serviceDataAccess.getFooterSettings()
    context.commit('setFooterSettings', footerSettings)
  },
  async loadHeaderSettings(context) {
    const headerSettings = await serviceDataAccess.getHeaderSettings()
    context.commit('setHeaderSettings', headerSettings)
  },
  loadConfig(context) {
    const apiBasePath = `${process.env.VUE_APP_APIURL}/api`
    context.commit('setConfig', { apiBasePath })
  },
  async loadSaleButtonSettings(context) {
    const saleSettings = await serviceDataAccess.getClientSettings('saleButtonsSettings')
    context.commit('setClientSettings', saleSettings)
  },
  async loadClientSettings(context, code) {
    if (context.state.clientSettings[code] != null) {
      return Promise.resolve()
    }
    const result = await serviceDataAccess.getClientSettings(code)
    context.commit('setClientSettings', new ClientSettingPayloadModel(result.settingCode, JSON.parse(result.settingValue)))
  },
  loadLocalization(context, language) {
    context.commit('setCurrentLocalization', language)
  }
}

const mutations = {
  setFooterSettings(state, settings) {
    state.footerSettings = settings
  },
  setHeaderSettings(state, settings) {
    state.headerSettings = settings
  },
  setClientSettings(state, settings) {
    state.clientSettings = settings
  },
  setConfig(state, config) {
    state.config = {
      ...config
    }
  },
  setCurrentLocalization(state, settings) {
    state.currentLocalization = settings
  },
  setContactsSettings(state, settings) {
    state.contactsSettings = settings
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
